import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { get } from '@/utils/api';
import { useQuery } from '@tanstack/react-query';
import { CallCenterDashboardResponse, featureKeys, featurePath } from '.';

type QueryFnType = typeof fetchCallCenterDashboard;

type UseCallCenterDashboardOptions = {
  enabled?: boolean;
  config?: QueryConfig<QueryFnType>;
};

const THIRTY_SECONDS = 1000 * 30;

// The dashboard payload is top-level `{ agent, queue, stats, meta }` -- there is
// no `{ data }` envelope for `get()` to unwrap, so its passthrough fallback
// returns the body as-is.
export const fetchCallCenterDashboard = () =>
  get<CallCenterDashboardResponse>(`${featurePath}/dashboard`, undefined, {
    skipErrorToast: true,
  });

export const useCallCenterDashboard = ({
  enabled = true,
  config = {},
}: UseCallCenterDashboardOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: featureKeys.dashboard(),
    queryFn: fetchCallCenterDashboard,
    refetchInterval: THIRTY_SECONDS,
    refetchOnWindowFocus: true,
    throwOnError: false,
    // Listed after the `config` spread deliberately: the explicit param wins
    // over any `config.enabled`.
    enabled,
  });
};
